// helpers for the Program Level Aggregate and Program Adjustment tables

// convert value to number, null/undefined/NaN become 0
const toNumber = (value) => {
    const parsed = parseFloat(value); 
    return Number.isNaN(parsed) ? 0 : parsed; 
}

// keep rows that belong to the given period id
export const filterByPeriod = (list = [], periodId) => {
    return list.filter(row => String(row['periodid']) === String(periodId)); 
}

// totals row ("Rebate Subtotal") for the program level aggregate table
export const buildProgramLevelTotals = (list = []) => {
    const totals = {
        feecategorydescription: 'Rebate Subtotal', 
        cyclenetspend: 0, 
        cyclenetinterchange: 0, 
        cycleincentiveamount: 0, 
    }; 
    list.forEach(row => {
        totals['cyclenetspend'] += toNumber(row['cyclenetspend']); 
        totals['cyclenetinterchange'] += toNumber(row['cyclenetinterchange']); 
        totals['cycleincentiveamount'] += toNumber(row['cycleincentiveamount']); 
    }); 
    // effective rebate rate ( cycleincentiveamount / cyclenetspend )
    if (totals['cycleincentiveamount'] !== 0 && totals['cyclenetspend'] !== 0) {
        totals['incentiverate'] = (totals['cycleincentiveamount'] / totals['cyclenetspend']).toFixed(4); 
    }
    return totals; 
}

// adjustment rows followed by summary rows (Adjustments Total, Rebate Subtotal, Total Rebate)
// returns an empty list when there are no adjustments so the table shows its empty state
export const buildProgramAdjustmentRows = (adjustments = [], rebateSubtotal = 0) => {
    if (adjustments.length === 0) {
        return []; 
    }
    const adjustmentsTotal = adjustments.reduce((sum, row) => sum + toNumber(row['adjustment_amount']), 0); 
    return [
        ...adjustments, 
        { description: 'Adjustments Total', adjustment_amount: adjustmentsTotal, isSummary: true, isFirstSummary: true }, 
        { description: 'Rebate Subtotal', adjustment_amount: rebateSubtotal, isSummary: true }, 
        { description: 'Total Rebate', adjustment_amount: rebateSubtotal + adjustmentsTotal, isSummary: true, isLastSummary: true }, 
    ]; 
}
